export const convertUTCToLocalString = (utcTimestamp, locale = "default", options = {}) => {
  // Ensure the string ends with 'Z' to treat it as UTC
  const date = new Date(utcTimestamp + "Z");

  // Default formatting options if none provided
  const defaultOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Set to false if you want 24-hour format
  };

  return date.toLocaleString(locale, { ...defaultOptions, ...options });
};

export function convertUTCToLocalForGames(utcString) {
  if (!utcString || !utcString.includes(" ")) return "Invalid date";

  const [datePart, timePart] = utcString.trim().split(" ");
  if (!datePart || !timePart) return "Invalid date";

  const [day, month, year] = datePart.split("-").map(Number); // <-- fixed here
  const [hour, minute] = timePart.split(":").map(Number);

  if ([year, month, day, hour, minute].some((val) => isNaN(val) || val === undefined)) return "Invalid date";

  const utcDate = new Date(Date.UTC(year, month - 1, day, hour, minute));

  const options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return utcDate.toLocaleString(undefined, options);
}

export function convertMsTimeToDate(timeInMs) {
  return new Date(timeInMs).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function capitalize(word) {
  if (!word) return "";
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
}
